export const PANEL_ID = 'jsw-nux-onboarding-checklist';
export const PANEL_WIDTH = 360;

export const PERFORMANCE_METRIC_PREFIX = 'onboarding-quickstart';
export const PERFORMANCE_MARK = {
	BUNDLE_LOAD_START: 'bundleLoaded',
	BUNDLE_LOAD_END: 'bundleLoadedEnd',
} as const;
